<template>

<div>
    <settingsNav></settingsNav>

    <v-container>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn class="secondary white--text" @click.stop="openUsersDialog(null)">
                    New User
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>

                        <v-card>
                            <v-card-title>
                                <v-card-title class="headline">
                                    Users
                                </v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        clearable
                                ></v-text-field>
                            </v-card-title>

                            <v-data-table
                                    :headers="headers"
                                    :items="getUsers"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                  <v-touch tag="tr"
                                           @doubletap="openUsersDialog(props.item.id)"
                                           @dblclick="openUsersDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.name }}</td>
                                        <td class="text-xs-left">{{ props.item.user_role.name }}</td>
                                        <td class="text-xs-left">{{ props.item.created_at }}</td>
                                        <td class="text-xs-left">{{ props.item.updated_at }}</td>
                                  </v-touch>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <addUserDialog></addUserDialog>

            </v-flex>
        </v-layout>

    </v-container>
</div>

</template>

<script>
    // Types
    import {
        Settings,
        UserSettings
    } from '../../../store/namespace-helper'

    import addUserDialog from '../Users/AddUserDialog.vue'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'users',
      components: {
        addUserDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'User-ID', value: 'id'},
                    {text: 'User name', value: 'name'},
                    {text: 'Role', value: 'role'},
                    {text: 'Created', value: 'created_at'},
                    {text: 'Updated', value: 'updated_at'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadUsers()
      },
      methods: {
        openUsersDialog (val) {
          if (val !== null) {
            let item = this.getUsers.find(x => x.id === val)
            this.$store.dispatch(UserSettings.actions.setSelectedUser, item)
          }
          this.$store.dispatch(UserSettings.actions.openCloseNewUserDialog)
        },
        loadUsers: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(UserSettings.actions.loadUsers, query)
        },
        throttledLoadUsers: _.debounce(function () {
          this.loadUsers()
        }, 450),
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        }

      },
      computed: {
        getUsers () {
          console.log('UserSettings.getters.users: ' + UserSettings.getters.users)
          this.total = this.$store.getters[UserSettings.getters.users].total
          return this.$store.getters[UserSettings.getters.users].data
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadUsers()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadUsers()
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/Users/Users.vue